<template>
    <div :class="'form-group input-group '+clase">
        <div v-if="prepend" class="input-group-prepend"><span class="input-group-text">{{prepend}}</span></div>
        <label class="has-float-label">
        <slot></slot>
        <span>{{label}}</span>
        </label>
        <div v-if="append" class="input-group-append"><span class="input-group-text">{{append}}</span></div>
        <slot name="validation"></slot>
    </div>
</template>
<script>
export default {
    name:'FloatLabel',
    props:['label', 'clase', 'prepend', 'append']
}
</script>